import {makeStyles, Menu, MenuItem,Tooltip} from "@material-ui/core";
import {useCallback, useRef, useState} from "react";

const useStyles = makeStyles(() => ({
  dotIcon: {
    width: 25,
    height: 25,
    cursor: 'pointer',
    verticalAlign:'middle'
  },
  menuItem: {
    padding: 0
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 30,
    marginLeft: 30,
    width: '100%'
  }
}));

interface IProps {
  item_session: any,
  onAddRemoveProject: () => void,
  delete_Experience: () => void,
  rename_Experiece: () => void,
  copy_Experience: () => void,
  duplicate_Experience?: () => void,
  onSaveBenchmark: () => void,
  onRemoveBenchmark: () => void,
  isreel: any
}

function DotMenuListing(props: IProps) {
  const classes = useStyles();
  const {
    item_session, onAddRemoveProject, copy_Experience, duplicate_Experience, delete_Experience, rename_Experiece, isreel, onSaveBenchmark,
    onRemoveBenchmark
  } = props;
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  
  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const onUpdateProjectIds = () => {
    setOpenMenu(false);
    onAddRemoveProject();
  };

  const onClickMenuItem = useCallback((value: string) => {
    switch (value) {
      case 'rename':
        rename_Experiece();
        break;
      case 'add_to_remove_from_project':
        onUpdateProjectIds();
        break;
      case 'copy':
        copy_Experience();
        break;
      case 'duplicate_experience':
        duplicate_Experience && duplicate_Experience();
        break;
      case 'delete':
        item_session.status != "LIVE" && delete_Experience();
        break;
      case 'save_benchmark':
        onSaveBenchmark();
        break;
      case 'remove_benchmark':
        onRemoveBenchmark();
        break;
    }
    handleMenuClose();
  }, [rename_Experiece, onUpdateProjectIds, copy_Experience, duplicate_Experience, handleMenuClose, item_session, delete_Experience, onSaveBenchmark]);

  const onClickReelsMenuItem = useCallback((index: string) => {
    switch (index) {
      case 'rename':
        rename_Experiece();
        break;
      case 'delete':
        item_session.status != "LIVE" && delete_Experience();
        break;
    }
    handleMenuClose();
  }, [rename_Experiece, delete_Experience, item_session, handleMenuClose]);

  const getDotMenuList = useCallback(() => {
    if (item_session.status === 'COMPLETED') {
      if (item_session.saved_benchmark) {
        return [
          {name: 'Rename', value: 'rename'},
          {name: 'Add to / Remove from Project', value: 'add_to_remove_from_project'},
          {name: 'Remove as Benchmark', value: 'remove_benchmark'},
          {name: 'Copy', value: 'copy',tooltipTxt: "Copy this experience as a new measurement experience"},
          {name: 'Duplicate', value: 'duplicate_experience',tooltipTxt:"Duplicate the entire experience with all measurements included"},
          {name: 'Delete', value: 'delete'}
        ]

      } else {
        return [
          {name: 'Rename', value: 'rename'},
          {name: 'Add to / Remove from Project', value: 'add_to_remove_from_project'},
          {name: 'Save as Benchmark', value: 'save_benchmark'},
          {name: 'Copy', value: 'copy',tooltipTxt: "Copy this experience as a new measurement experience"},
          {name: 'Duplicate', value: 'duplicate_experience',tooltipTxt:"Duplicate the entire experience with all measurements included"},
          {name: 'Delete', value: 'delete'}
        ]
      }
    } else {
      return  [
        {name: 'Rename', value: 'rename'},
        {name: 'Add to / Remove from Project', value: 'add_to_remove_from_project'},
        {name: 'Copy', value: 'copy',tooltipTxt: "Copy this experience as a new measurement experience"},
        {name: 'Delete', value: 'delete'}
      ]
    }
  }, [item_session]);

  return (
    <div>
      <img
        src={'/assets/icons/participant/dots-menu.svg'}
        alt='dot menu'
        className={classes.dotIcon}
        ref={anchorRef}
        onClick={handleMenuOpen}
      />
      <Menu
        anchorEl={anchorRef.current}
        onClose={handleMenuClose}
        open={openMenu}
        PaperProps={{
          style: {width: 'auto', marginTop: 50, borderRadius: 12}
        }}
      >
        {
          isreel ? [{name: 'Rename', value: 'rename'}, {name: 'Delete', value: 'delete'}].map((item, index) => (
            <MenuItem
              className={classes.menuItem}
              key={index}
              onClick={() => onClickReelsMenuItem(item.value)}
            >
              {
                item.value === 'delete'
                  ? item_session.status != "LIVE" && <p className={classes.btn}>{ item.name }</p>
                  : <p className={classes.btn}>{ item.name }</p>
              }
            </MenuItem>
          )) :
            getDotMenuList().map((item, index) => (
              <Tooltip title={item.tooltipTxt ? item.tooltipTxt : ""} key={index+11}>
              <MenuItem
                className={classes.menuItem}
                key={index}
                onClick={() => onClickMenuItem(item.value)}
              >
                {
                  item.value === 'delete'
                    ? item_session.status != "LIVE" && <p className={classes.btn}>{ item.name }</p>
                    : <p className={classes.btn}>{ item.name }</p>
                }
              </MenuItem>
              </Tooltip>
            ))
        }
      </Menu>
    </div>
  )
}

export default DotMenuListing;
